import React,{useState} from 'react';
import AuthLogic from '../components/Auth/AuthLogic';
import Footer from '../components/Footer';
import Navbar from '../components/Navbar';
import Sidebar from '../components/Sidebar';





function AuthPage() {
   const user = 'Amal'
    const [isOpen,setIsOpen]= useState(false);
    const toggle= ()=>{
        setIsOpen(!isOpen);
    }
    return (
        <div>
            <Sidebar isOpen={isOpen} toggle={toggle} />
            <Navbar toggle={toggle} log={user} />  
            <AuthLogic />


            <Footer />
        </div>
    )
}

export default AuthPage